import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import type { ProviderAppointments } from '../../models/providerHome';

export const useProviderAppointments = () => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const { data, isLoading, isError } = useQuery<ProviderAppointments, Error>({
    queryKey: ['provider-home-appointments', userToken],
    queryFn: () =>
      api({ route: '/private/provider-home/appointments', token: userToken }),
    enabled: isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    today: data?.today ?? [],
    tomorrow: data?.tomorrow ?? [],
    isLoading,
    isError,
  };
};
